// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1o6fm","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__yXmYj"};